module.exports = __webpack_public_path__ + "img/img-campaign.55d5cf4f.jpg";